import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';

import {
	getTranslatedString,
	useTranslations,
	mergeHtmlAttributesObjects,
	SearchField
} from '@bosch/bt-ui';

import './SearchBox.css';
import withErrorHandler from './ErrorHandler';

const SearchBox = (props) => {
	const translations = useTranslations();

	const defaultHtmlAttributes = {
		placeholder: getTranslatedString('Search', translations)
	};

	const htmlAttributes = mergeHtmlAttributesObjects(defaultHtmlAttributes, props.htmlAttributes);

	return (
		<SearchField
			type="input"
			{...props}
			htmlAttributes={htmlAttributes}
		/>
	);
}

export default withErrorHandler(SearchBox);